<template>
  <div class=" res-card p-n mb-2 h-100-XXX">
    <div class="res-card-header sub-header geoff-border-bottom fs-15 fw-600">{{ title }}</div>

    <div v-if="showLucky || showReset" class="section-action-wr">
      <vue-button v-if="showLucky" cls="main" sm @click="getLuckyNumbers">Lucky Dip</vue-button>
      <vue-button v-if="showReset" cls="main" sm @click="clearSelectedNumbers">Reset</vue-button>
    </div>

    <div class="lotto-wrapper py-2" :class="{ 'px-2': $store.state.isMobile }">
      <div v-for="num in displayItems" :key="num">
        <lotto-ball-number :number="parseInt(num)" @click="ballClick(num)" class="desk-c-pointer" :class="{ 'white': !value.includes(num) }"></lotto-ball-number>
      </div>
    </div>
  </div>
</template>

<script>
  import VueButton from "@/components/UI/VueButton";
  import LottoBallNumber from "@/components/UI/LottoBallNumber";
  export default {
  name: "LottoEventBet",
    components: {
      VueButton,
      LottoBallNumber
    },
    props:{
      maxBalls: {
        type: Number,
        required: true,
        default: 6
      },
      title: {
        type: String,
        default: 'Select numbers'
      },
      modelValue: {
        type: Array
      },
      showLucky: {
        type: Boolean
      },
      showReset: {
        type: Boolean
      }
    },
    emits: ['update:modelValue'],
    data: () => {
      return {
      }
    },
    watch:{
      maxBalls() {
        this.normalizeMax()
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value) {
          this.$emit('update:modelValue', value)
        }
      },

      displayItems () {
        return Array.from({length: 49}, (_, i) => i + 1)
      },
    },

    methods: {
      normalizeMax() {
        if (this.value?.length > this.maxBalls) {
          this.value = this.value.slice(0, this.maxBalls)
      }
      },
      ballClick(num) {
        const isSelected = this.value.includes(num)
        // length
        if (this.value.length >= this.maxBalls && !isSelected) {
          // reached max balls
          return
        }
        if (isSelected) {
          this.value = this.value.filter(el => el !== num)
        }
        else {
          this.value.push(num)
        }
      },

      getLuckyNumbers( ){
        let arr = [];
        while(arr.length < 5){
            var r = Math.floor(Math.random() * 49) + 1;
            if(arr.indexOf(r) === -1) arr.push(r);
        }
        this.value = arr
      },

      clearSelectedNumbers() {
        this.value = []
      },
    }
  }
</script>

<style scoped lang="scss">
  .res-card{
    width: auto;
    background-color: var(--geoff-bg-section);
    border-radius: 0.25rem;
  }

  .item-ball {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    border: 1px solid var(--geoff-accent);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .item-title {
    span {
      display: inline-block;
      margin-right: 0.5rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .lotto-wrapper {
    display: grid;
    grid-gap: 0.5rem;
    grid-template-columns: repeat(auto-fill, minmax(2.5rem, 1fr));
  }

  .section-action-wr {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
</style>